import _ from 'lodash';
import { EventEmitter } from 'events';

export class Model extends EventEmitter {

  constructor( ...opts ) {
    super();
    _.assign( this, ...opts );
    _.defaults( this, {
      flags : [],
    } );
  }

  flag( ...names ) {
    return _.some( names, name => _.includes( this.flags, name ) );
  }

  toJSON() {
    const data = _.pickBy( this, ( val, key ) => {
      if ( _.isNil( val ) ) return false;
      if ( _.isFunction( val ) ) return false;
      if ( key === 'events' || key === 'eventsCount' ) return false;
      return ! _.includes( [ '_events', '_eventsCount' ], key );
    } );
    return _.mapKeys( data, ( val, key ) => key.replace( /^_/u, '' ) );

  }

  getValidators() {
    let iter = this;
    const validators = [];
    while ( iter ) {
      validators.push( iter.validators );
      iter = Object.getPrototypeOf( iter );
    }
    return _.flattenDeep( validators );
  }

  validate() {
    const validators = this.getValidators();
    const errors = _.compact( _.map( validators, validator => {
      return validator.call( this, this );
    } ) );
    return errors;
  }

  // [ Symbol.for( 'nodejs.util.inspect.custom' ) ]() { return this.toJSON(); }

}
